import React from "react";
import loader from '../data/img/loader.gif';
import { jsx } from '@emotion/core';

const Loading = () => {

  return (
    <div className="loading" css={{
      display: 'none',
      backgroundColor: 'rgba(0,0,0,.2)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 999
    }}>
    <img css={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }}
    src={loader} width={100} />
    </div>
  )
};

export default Loading;
